export class KafkaTopicInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "partitionCount",
            "baseName": "partitionCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "messageCountEstimate",
            "baseName": "messageCountEstimate",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "retentionMs",
            "baseName": "retentionMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "oldestMessageTs",
            "baseName": "oldestMessageTs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "newestMessageTs",
            "baseName": "newestMessageTs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "isInternal",
            "baseName": "isInternal",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaTopicInfo.attributeTypeMap;
    }
    constructor() {
    }
}
